import { useState, useEffect } from 'react'
import { ideasLoader } from '../apiCalls'
import IdeaComp from '../components/ideaComp'
import Stack from 'react-bootstrap/Stack'
import NewIdea from './NewIdea'
import { Button } from 'react-bootstrap'

const ShowIdeas = (props) => {
    const user = props.mods.currentUser.user

    const [ideas, setIdeas] = useState([])
    const [newIdeaToggle, setNewIdeaToggle] = useState(false)
    
    async function getIdeas() {
        try {
            let myIdeas = await ideasLoader()
            setIdeas(myIdeas)
        } catch(err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getIdeas()
    }, [])

    function buildList() {
        const ideaArr = ideas.map((value, idx) => {
            return (
                <div key={idx}>
                    <IdeaComp mods={{value, getIdeas, user}} />
                </div>
            )
        })
        return ideaArr
    }

    function handleNew() {
        setNewIdeaToggle(true)
    }

    return (
        <div className="ideaListContainer">
            <Button onClick={handleNew} className="mb-2 btn-dark defaultButton editButton">New Idea</Button>
            <Stack gap={1} className="listStack">
                {ideas ? buildList() : <p>Loading Ideas...</p>}
            </Stack>
            {newIdeaToggle ? <NewIdea mods={{setNewIdeaToggle, getIdeas}} /> : null }
        </div>
    )
    
}

export default ShowIdeas